import { render, staticRenderFns } from "./AddLead.vue?vue&type=template&id=a1444126"
import script from "./AddLead.vue?vue&type=script&lang=js"
export * from "./AddLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports